import React from 'react'

import GridElementContainer from '../../../GridElementContainer'
import NewsItem from './NewsItem'

import { tutorNews } from '../../../../../../../constants'

const News = ({ containerClassName = '', className = '' }) => {
  const tutorNewsContent = tutorNews.map((newsItem) => {
    return <NewsItem key={newsItem.id} newsItem={newsItem} />
  })

  return (
    <GridElementContainer className={containerClassName} title="News">
      <div className={`grid gap-y-[8px] w-[calc(100%+5px)] pr-[5px] ${className}`}>
        {tutorNewsContent}
      </div>
    </GridElementContainer>
  )
}

export default News
